module.exports = __webpack_public_path__ + "img/santa_fe.68e6094f.png";